export default __webpack_public_path__ + "static/media/10_logo.4f1366a0.png";